import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { antdTheme } from "@/constant/theme";

export type ThemeName = "light" | "dark" | "system";

interface ThemeOption {
	name: ThemeName;
	label: string;
	icon?: string;
}

export const useThemeStore = defineStore(
	"theme",
	() => {
		const themeOptions: ThemeOption[] = [
			{ name: "light", label: "浅色" },
			{ name: "dark", label: "深色" },
			{ name: "system", label: "跟随系统" },
		];

		const themeName = ref<ThemeName>("light");
		const themeTitle = computed(() => {
			const theme = themeOptions.find((item) => item.name === themeName.value);

			return theme ? theme.label : "";
		});

		const setTheme = (name: ThemeName) => {
			themeName.value = name;

			initTheme();
		};

		const setActualTheme = (actualTheme: ThemeName | "") => {
			if (!actualTheme) {
				return;
			}

			// 设置主题
			document.documentElement.setAttribute("data-theme", actualTheme);
			// 移除所有主题类
			document.documentElement.classList.remove("dark", "light");
			// 添加当前主题类
			document.documentElement.classList.add(actualTheme);
		};

		const initTheme = () => {
			let actualTheme = themeName.value;

			if (themeName.value === "system") {
				const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;

				actualTheme = isDarkMode ? "dark" : "light";

				window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
					setActualTheme(actualTheme);
				});
			}

			setActualTheme(actualTheme);
		};

		const actualAntdTheme = computed(() => {
			let actualTheme = themeName.value;

			if (themeName.value === "system") {
				const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;

				actualTheme = isDarkMode ? "dark" : "light";
			}

			return antdTheme[actualTheme] || antdTheme.light;
		});

		return {
			themeOptions,
			themeName,
			themeTitle,
			actualAntdTheme,
			setTheme,
			initTheme,
		};
	},
	{
		// 开启数据持久化
		persist: [
			{
				storage: localStorage,
			},
		],
	}
);
